import { createSelector } from '@reduxjs/toolkit';

import { SYSTEM_DOMAIN_BILLING_TIERS } from '../../constants/system_domains';
import type { AppState } from '../../store/types';

const getMergedSettings = (state: AppState) => {
  return state.settings.merged;
};

export const selectBillingTier = createSelector(
  getMergedSettings,
  (mergedSettings) => {
    return mergedSettings.billing_tier;
  },
);

export const selectIsProOrEnterpriseTier = createSelector(
  selectBillingTier,
  (billingTier): boolean => {
    return (
      billingTier === SYSTEM_DOMAIN_BILLING_TIERS.PRO ||
      billingTier === SYSTEM_DOMAIN_BILLING_TIERS.ENTERPRISE ||
      billingTier === SYSTEM_DOMAIN_BILLING_TIERS.PRO_LEGACY_2025 ||
      billingTier === SYSTEM_DOMAIN_BILLING_TIERS.ENTERPRISE_LEGACY_2025
    );
  },
);
